import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e25a582"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "edit-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "mt-3 page-title" }, "Modifier un matricule utilisateur", -1))
const _hoisted_3 = {
  key: 0,
  class: "flex justify-content-center"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "form-container"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5 mr-2",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M15 19l-7-7 7-7"
  })
], -1))
const _hoisted_7 = { class: "mx-auto shadow-md p-6 rounded-lg w-[90%] md:w-[80%] lg:w-[50%]" }
const _hoisted_8 = { class: "justify-center" }
const _hoisted_9 = {
  key: 0,
  class: "user-details"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Client lié au matricule", -1))
const _hoisted_11 = { class: "user-info" }
const _hoisted_12 = { class: "info-row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info-label" }, "Email:", -1))
const _hoisted_14 = { class: "info-value" }
const _hoisted_15 = { class: "info-row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info-label" }, "Prénom:", -1))
const _hoisted_17 = { class: "info-value" }
const _hoisted_18 = { class: "info-row" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info-label" }, "Nom:", -1))
const _hoisted_20 = { class: "info-value" }
const _hoisted_21 = {
  key: 1,
  class: "no-user-assigned"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Aucun utilisateur n'est affecté à cette matricule.", -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "mt-3" }
const _hoisted_25 = {
  key: 1,
  class: "form-container error"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5 mr-2",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M15 19l-7-7 7-7"
  })
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Matricule non trouvé.", -1))

import {useCompanyMatriculeStore} from "@/stores/companyMatricule/companyMatriculeStore";
import {fetchCompanyMatricule} from "@/_services/companyMatricule/companyMatricule";
import {getPaginatedUsersWithoutMatriculeByCompanyForDropDown} from "@/_services/user/user";
import ApiService from "@/_services/api.service";
import {IFormkitDropDown} from "@/models/formkit/dropDown/IFormkitDropDown";
import {ref, watch, computed, onMounted, onUnmounted} from "vue";
import {useRoute, onBeforeRouteLeave, onBeforeRouteUpdate} from 'vue-router';
import ProgressSpinner from "primevue/progressspinner";
import router from "@/router";
import swal from "@/_helpers/swal";
import {IUserMatriculeByCompany} from "@/models/companyMatricule/IUserMatriculeByCompany";

interface IEditCompanyMatriculeForm {
    userMatricule: string;
    selectedUser?: undefined | string;
    available: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EditCompanyMatricule',
  setup(__props) {

const route = useRoute();
const store = useCompanyMatriculeStore();
const isLoading = ref(true);
const companyMatricule = computed(() => store.selectedMatricule);

const formData = ref<IEditCompanyMatriculeForm>({
    userMatricule: '',
    selectedUser: undefined,
    available: false,
});

onMounted(async() => {
    const urlMatriculeUuid = route.params.uuid as string;
    if (companyMatricule.value && companyMatricule.value.uuid === urlMatriculeUuid) {
        formData.value.userMatricule = companyMatricule.value.userMatricule;
        formData.value.available = companyMatricule.value.available;
        formData.value.selectedUser = (companyMatricule.value.user)
            ? formData.value.selectedUser = companyMatricule.value.user.uuid
            : undefined;
            
        isLoading.value = false;
    } else {
        await fetchCompanyMatriculeByUuidIfNotInStore(urlMatriculeUuid);
    }
});

onUnmounted(() => {
    store.clearSelectedMatricule();
});

watch(
    companyMatricule,
    (newValue) => {
        if (newValue) {
            formData.value.userMatricule = newValue.userMatricule;
            formData.value.available = newValue.available;
        }
    },
    { immediate: true }
);

onBeforeRouteLeave(() => {
    store.clearSelectedMatricule();
});

onBeforeRouteUpdate(() => {
    store.clearSelectedMatricule();
});

const fetchCompanyMatriculeByUuidIfNotInStore = async (uuid: string) => {
    const [isLoadingResponse, companyMatriculeResponse] = await fetchCompanyMatricule(uuid);
    isLoading.value = isLoadingResponse;
    if (companyMatriculeResponse) {
        store.setSelectedMatricule(companyMatriculeResponse);
    }
};

async function searchUsersWithoutMatriculeByCompany({ search, page, hasNextPage }) {
    if (companyMatricule.value && companyMatricule.value?.company.uuid) {
        const [totalCompaniesRecordsForDropDown, usersWithoutMatriculeList] = await getPaginatedUsersWithoutMatriculeByCompanyForDropDown(
            companyMatricule.value?.company.uuid,
            5,
            page,
            search,
            true,
        );
        
        // Always prepend the current store user to results if it exists
        let finalUsersList = [...usersWithoutMatriculeList];

        if (companyMatricule.value?.user && page === 1) {
            const defaultSelectedUser: IFormkitDropDown = {
                label: companyMatricule.value.user.fullname,
                value: companyMatricule.value.user.uuid,
            };

            // Check if the store user matches the search criteria
            const searchLower = search?.toLowerCase() || '';
            const userMatchesSearch = !searchLower || companyMatricule.value.user.fullname.toLowerCase().includes(searchLower);
            if (userMatchesSearch) {
                // Remove duplicates if the store user is already in the list
                finalUsersList = finalUsersList.filter(u => u.value !== defaultSelectedUser.value);
                // Add store user at the beginning
                finalUsersList.unshift(defaultSelectedUser);
            }
        }

        const hasItems = usersWithoutMatriculeList.length > 0;
        if (hasItems && page !== totalCompaniesRecordsForDropDown) {
            hasNextPage();
        }

        return finalUsersList;
    }

    return [];
}

const cannotEditAvailable = () => {
    return companyMatricule.value?.user;
};

const preventSpaceOnWriteText = (event: KeyboardEvent) => {
    if (event.key === ' ' || event.code === 'Space') {
        event.preventDefault();
    }
};

const redirectToCompanyMatriculeList = (matricule: IUserMatriculeByCompany) => {
    store.setSelectedCompany({
        uuid: matricule.company.uuid,
        name: matricule.company.name,
    });
    
    router.push({
        name: 'userMatriculesByCompany',
        params: { uuid: matricule.company.uuid }
    });
};

const redirectToCompanyList = () => {
    store.clearAll();
    
    router.push({name: 'companyMatriculeWithUserList'});
};

const validateMatricule = (node) => {
    const value = node.value;
    if (!value) return true;

    const forbiddenChars = [' ', '.', ',', ';', '_'];
    for (const char of forbiddenChars) {
        if (value.includes(char)) {
            return false;
        }
    }

    return true;
};

const onSubmit = async () => {
    if (!companyMatricule.value) {
        return;
    }

    const companyMatriculeUuid = companyMatricule.value.uuid;
    const companyUuid = companyMatricule.value?.company.uuid;
    const companyName = companyMatricule.value?.company.name;
    try {
        const payload = {
            userMatricule: formData.value.userMatricule.trim(),
            available: formData.value.available,
            userUuid: formData.value.selectedUser || null,
        };

       await ApiService.patchWithoutSlug(`/admin/company-matricule/${companyMatriculeUuid}`, payload)
            .then((response) => {
                swal.success("Succès", "Les modifications ont bien été prises en compte");
                
                store.setSelectedCompany({
                    uuid: companyUuid,
                    name: companyName,
                });
                
                router.push({ name: 'userMatriculesByCompany' , params: { uuid: companyUuid }});
        });
    } catch (error: any) {
        console.error('Error when saving company matricule:', error);
        
        const apiResponse = error.response.data;
        let message = "Une Erreur est surevenue";
        if (apiResponse.errors.length) {
            const tempMessage = apiResponse.errors[0].message;
            if (
                tempMessage === 'Cet utilisateur a déjà un matricule.'
                || tempMessage === 'Ce matricule existe déjà pour cette entreprise.')
            {
                message = tempMessage;
            }
        }
        
        swal.error(message);
    }
};

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_unref(ProgressSpinner), { "aria-label": "Chargement..." })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (companyMatricule.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (redirectToCompanyMatriculeList(companyMatricule.value))),
                  class: "inline-flex items-center px-4 py-2 border border-blue-500 text-blue-500 bg-white transition-colors duration-300 hover:bg-blue-500 hover:text-white rounded-md text-sm"
                }, [
                  _hoisted_6,
                  _createTextVNode(" Retour ")
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_FormKit, {
                      type: "form",
                      "outer-class": "w-full",
                      actions: false,
                      model: formData.value,
                      onSubmit: onSubmit,
                      "incomplete-message": "Veuillez remplir tous les champs correctement."
                    }, {
                      default: _withCtx(({state: { valid }}) => [
                        _createVNode(_component_FormKit, {
                          type: "text",
                          name: "userMatricule",
                          label: "Matricule*",
                          placeholder: "Enter user matricule",
                          modelValue: formData.value.userMatricule,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.userMatricule) = $event)),
                          validation: "required|length:1,25|validateMatricule",
                          "validation-visibility": "live",
                          "validation-rules": { validateMatricule: validateMatricule },
                          "validation-messages": {
                                    required: 'Veuillez renseigner le matricule',
                                    length: 'Veuillez renseigner un matricule entre 1 and 25 caractères',
                                    validateMatricule: 'Le matricule ne peut pas contenir d\'espaces, points (.), virgules (,), points-virgules (;) ou underscores (_)'
                                },
                          onKeydown: preventSpaceOnWriteText
                        }, null, 8, ["modelValue", "validation-rules", "validation-messages"]),
                        _createVNode(_component_FormKit, {
                          type: "checkbox",
                          name: "available",
                          label: "Available",
                          modelValue: formData.value.available,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.available) = $event)),
                          disabled: cannotEditAvailable()
                        }, null, 8, ["modelValue", "disabled"]),
                        _createVNode(_component_FormKit, {
                          type: "autocomplete",
                          name: "companyUuid",
                          "empty-message": "Aucun utilisateur",
                          modelValue: formData.value.selectedUser,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.selectedUser) = $event)),
                          label: "Utilisateur",
                          placeholder: "Sélectionner un utilisateur",
                          "selection-appearance": "option",
                          options: searchUsersWithoutMatriculeByCompany
                        }, null, 8, ["modelValue"]),
                        (companyMatricule.value.user)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              _hoisted_10,
                              _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("div", _hoisted_12, [
                                  _hoisted_13,
                                  _createElementVNode("span", _hoisted_14, _toDisplayString(companyMatricule.value.user.email), 1)
                                ]),
                                _createElementVNode("div", _hoisted_15, [
                                  _hoisted_16,
                                  _createElementVNode("span", _hoisted_17, _toDisplayString(companyMatricule.value.user.firstname), 1)
                                ]),
                                _createElementVNode("div", _hoisted_18, [
                                  _hoisted_19,
                                  _createElementVNode("span", _hoisted_20, _toDisplayString(companyMatricule.value.user.lastname), 1)
                                ])
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23)),
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(_component_FormKit, {
                            type: "submit",
                            label: "Enregistrer",
                            "input-class": "btn-primary",
                            disabled: !valid
                          }, null, 8, ["disabled"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["model"])
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (redirectToCompanyList())),
                  class: "inline-flex items-center px-4 py-2 border border-blue-500 text-blue-500 bg-white transition-colors duration-300 hover:bg-blue-500 hover:text-white rounded-md text-sm"
                }, [
                  _hoisted_26,
                  _createTextVNode(" Retour ")
                ]),
                _hoisted_27
              ]))
        ]))
  ]))
}
}

})